export default __webpack_public_path__ + "static/media/LightLogo.c0297229.png";